
import { defineComponent } from "vue";


export default defineComponent({
    name: "home-sso",
    components: {},

});
